"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InspectSession = void 0;
const utils_1 = require("@streamr/utils");
const eventemitter3_1 = require("eventemitter3");
const createMessageKey = (messageId) => {
    return `${(0, utils_1.toUserId)(messageId.publisherId)}:${messageId.messageChainId}:${messageId.timestamp}:${messageId.sequenceNumber}`;
};
class InspectSession extends eventemitter3_1.EventEmitter {
    // Boolean indicates if the message has been received by the inspected node
    inspectionMessages = new Map();
    inspectedNode;
    constructor(options) {
        super();
        this.inspectedNode = options.inspectedNode;
    }
    markMessage(remoteNodeId, messageId) {
        const messageKey = createMessageKey(messageId);
        if (!this.inspectionMessages.has(messageKey)) {
            this.inspectionMessages.set(messageKey, remoteNodeId === this.inspectedNode);
        }
        else if (this.inspectionMessages.has(messageKey)
            && this.inspectionMessages.get(messageKey) === false
            && remoteNodeId === this.inspectedNode) {
            this.emit('done');
        }
        else if (this.inspectionMessages.has(messageKey)
            && this.inspectionMessages.get(messageKey) === true) {
            this.emit('done');
        }
    }
    getInspectedMessageCount() {
        return this.inspectionMessages.size;
    }
    onlyMarkedByInspectedNode() {
        return Array.from(this.inspectionMessages.values()).every((value) => value === true);
    }
    stop() {
        this.emit('done');
    }
}
exports.InspectSession = InspectSession;
//# sourceMappingURL=InspectSession.js.map